import { matchPath } from "react-router-dom";
import { creationModuleRoutes } from "../routes/inner-routes";

export const isCreationModule = () => {
  const path = window.location.pathname;

  return creationModuleRoutes.some((route) => matchPath({ path: route, end: true }, path));
};